import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/route-patterns'

const URL_ADMIN_STOREFRONT_SHORTCUTS_BAR = `${URL_APP_ADMIN}/storefront-shortcuts-bar`
const URL_ADMIN_STOREFRONT_SHORTCUTS_BAR_RETAILER_CATEGORY_EDIT = `${URL_ADMIN_STOREFRONT_SHORTCUTS_BAR}/retailer-category/edit`
const URL_ADMIN_STOREFRONT_SHORTCUTS_BAR_RETAILER_EDIT = `${URL_ADMIN_STOREFRONT_SHORTCUTS_BAR}/retailer/edit`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-storefront-shortcuts-bar'>
  | DashRouteType<'app-admin-storefront-shortcuts-bar-retailer-category-edit'>
  | DashRouteType<'app-admin-storefront-shortcuts-bar-retailer-edit'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-storefront-shortcuts-bar': URL_ADMIN_STOREFRONT_SHORTCUTS_BAR,
  'app-admin-storefront-shortcuts-bar-retailer-category-edit':
    URL_ADMIN_STOREFRONT_SHORTCUTS_BAR_RETAILER_CATEGORY_EDIT,
  'app-admin-storefront-shortcuts-bar-retailer-edit':
    URL_ADMIN_STOREFRONT_SHORTCUTS_BAR_RETAILER_EDIT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
